import Masonry from "masonry-layout";

export function initializeMasonry() {
    $('[data-masonry-layout="true"]').each(function () {
        let self = this;
        var msnry = new Masonry(self, {
            percentPosition: true,
            horizontalOrder: true,
        });
    });
}
